const hostname = typeof window !== 'undefined' ? window.location.hostname : '';

export type AppEnv = 'production' | 'staging' | 'development';

export const APP_ENV: AppEnv =
  hostname.includes('staging') ? 'staging' :
  hostname === 'localhost' || hostname === '127.0.0.1' ? 'development' :
  'production';

/**
 * Local dev only: `localStorage` key `MAESTRO_DEV_CLOUD` = `staging` (default) | `production`.
 * When `production`, localhost uses the same cloud API/WebSocket as production builds.
 *
 * April 2026: shim while api-staging was missing secrets/out of date — use `production` until
 * staging is repaired (see `00_Architecture/TECH_DEBT.md` items 2 and 7). Remove or narrow once
 * staging matches production.
 */
function readMaestroDevCloud(): 'staging' | 'production' {
  if (APP_ENV !== 'development' || typeof window === 'undefined') return 'staging';
  try {
    const raw = localStorage.getItem('MAESTRO_DEV_CLOUD');
    const v = typeof raw === 'string' ? raw.trim() : '';
    if (v === 'production') return 'production';
    return 'staging';
  } catch {
    return 'staging';
  }
}

const DEV_CLOUD = readMaestroDevCloud();

export const API_BASE =
  APP_ENV === 'development'
    ? DEV_CLOUD === 'production'
      ? 'https://api.maestroaudio.net'
      : 'https://api-staging.maestroaudio.net'
    : 'https://api.maestroaudio.net';

export const WS_BASE =
  APP_ENV === 'development'
    ? DEV_CLOUD === 'production'
      ? 'wss://api.maestroaudio.net'
      : 'wss://api-staging.maestroaudio.net'
    : 'wss://api.maestroaudio.net';

export const IS_BETA = APP_ENV !== 'production';

if (typeof window !== 'undefined' && APP_ENV === 'development') {
  let raw: string | null = null;
  try {
    raw = localStorage.getItem('MAESTRO_DEV_CLOUD');
  } catch {
    /* ignore */
  }
  console.log('[Maestro dev cloud]', {
    api: API_BASE,
    ws: WS_BASE,
    MAESTRO_DEV_CLOUD: raw,
    resolved: DEV_CLOUD,
  });
}
